export default __webpack_public_path__ + "static/media/Luke_Hampton_Resume.edf75ab8.PDF";